const zh = {
    nav:{
    	service:'服务介绍',
		login: '登录',
		logout: '退出登录',
		enterprise: '企业用户',
		person: '个人用户',
		business: '商家',
		forum: '论坛',
		demand: '需求',
		ENTERPRISE:"企业展示&搜索",
		AGENT:'代理',
		CHARTER:'租家',
		INSURANCE:'保险',
		LOGISTIC:'物流',
		MAKER:'制作商',
		MEDIA:'媒体',
		OWNER:'租家',
		RBYARD:'修造船厂',
		SHIPMANAGEMENT:'船舶管理',
		SUPPLIER:'供应商',
		TRAINING:'培训',
		FORUM:'论坛',
		DEMAND:'需求',

		privacypolicy:'隐私政策',
		userterms:'用户条款',
		complaintsandsuggestions:'投诉与建议',
		contactus:'联系我们',
		copyright:'版权所有',
		AllRightsReserved:"保留所有权利",
		ENTERPRISEEXHIBITIONBOOTH:'企业展台',

		pleaseselect:'企业分类',
		counteydistrict:'国家/地区',
		cityport:'城市/港口',
		companyname:'公司名称',
		theproduct:'您正在寻找的产品/服务',
		
		SEARCH:'搜索',
		ForumPost:'论坛帖',
		ReleaseDemand:'需求帖',
		ForumPostEditing:'论坛帖子编辑',
		ReleaseDemandEditing:'需求帖子编辑',

		LoginAccount:'登录帐号',
		Noaccountleft:'尚无账号',
		CreateAccount:'创建账号',
		EnterpriseUsers:'企业用户',
		IndividualUsers:'个人用户',
		Email:'电子邮箱',
		EnterEmail:'输入电子邮箱',
		Thisisarequiredfield:'这是必填字段',
		Password:'密码',
		ForgetPassword:'忘记密码',
		Ihavereadandagreewith:'我已阅读并同意',
		UserAgreement:'用户协议',
		Logon:'登录',
		MobileNo:'电话号码',
		InvitationCode:'邀请码',
		Alreadyhaveanaccount:'已有账号',
		passwordmustbe:'密码须为由超过8位的字母和数字组成',
		Slgnup:'注册',
		Code:'发送验证码',
		EmailCode:'邮件验证码',
		ConfirmPassword:'确认密码',
		Reset:'重置',
		officialnotification:'官方通知',
		Replytomessageboard:'留言板回复',
		ComplaintsandSuggestionsResponse:'投诉与建议回复',
		Notificationmessagelist:'通知消息列表',
		Allread:'全部已读',
		Official:'官方',
		View:'查看',
		ComplaintsandSuggestions:'投诉与建议',
		Officialnotificationcontent:'官方通知',
		Pleasechooseacategory:'请选择分类',

		ForumUsage:'论坛使用情况',
		FunctionIntroduction:'功能介绍',
		ForumUsagecontent:'需求使用2022年，中兴进入战略超越期。在稳步巩固其CT业务作为第一条曲线的同时，中兴通讯积极为公司创造了第二条增长曲线，包括IT（包括服务器和存储等IT基础设施，以及5G行业和汽车电子的数字化转型业务）',
		DemandUsage:'需求使用情况',
		CompanyIntroduction:'需求用途公司介绍',
		DemandUsagecontent:'',
		MerchantDisplay:'商家展示',
		MerchantDisplayandEditingDiagram:'商户显示和编辑图',
		MerchantDisplaycontent:'',

		ENTERPRISEHOMEPAGEEDITING:'企业主页',
		ENTONEHOMEPAGEEDITING:'个人主页',
		ENTERPRIPAGEEDITING:'编辑企业主页',
		IndividualUserHomepageEditing:'编辑个人主页',
		Contact:'联系',
		Collect:'收藏',
		UploadCompanybrochure:'上传公司宣传册',
		OfficialWebsite:'官方网站',
		CompanyIntroduction:'公司介绍',
		BusinessKeywordEntry:'公司介绍业务关键字输入',
		PersonalKeywordEntry:'个人介绍关键词录入',
		PersonalKeyword:'个人介绍关键词',
		ProductServiceIntroduction:'产品/服务介绍',
		ProductServiceIntroductionPerson:'个人职业/经验介绍',
		UploadcompanyRegistryfile:'上传公司注册文件',
		Uploadyourresume:'上传个人简历',
		personalCV:'个人简历',
		companyRegistryfile:"企业注册文件",
		Companybrochure:"企业宣传册",
		Name:'姓名',
		CompanyIntroductionFill:'请录入公司介绍',
		PersonalIntroductionFill:'请录入个人介绍',
		ADDENGLISHCompanyIntroduction:"添加英文公司简介",
		ADDCHINESEDECompanyIntroduction:"添加中文公司简介",
		phonenumber:'电话号码',
		Email:'邮箱',
		Save:'保存',
		Preview:'预览',
		quitPreview:'退出预览',
		ConfirmDisplay:'确认展示',
		ReturntoEdit:'返回编辑',

		copylink:'复制链接',
		Collection:'收藏',
		Comment:'评论',
		Pleaseenteryourcomment:'请输入您的评论',
		Picture:'图片',
		Cancel:'取消',
		confirm:'确认',

		MessageDetails:'消息',

		prompt:'提示',
		Doyouwanttologout:'是否退出登录',
		WhetherToCloseTheAccount:'是否注销账号(所有数据将被清除)',
		// EditHomePage:'编辑主页',
		EditHomePageI:'编辑个人主页',
		EditHomePageE:'编辑企业主页',
		MyPosts:'论坛贴',
		MyDemand:'需求贴',
		Collection:'收藏',
		Like:'喜欢',
		Drafts:'草稿',
		EnterpriseAccount:'企业账户',
		InvoiceApplication:'发票申请',
		ForumPosts:'论坛贴',
		RequestPosts:'需求贴',
		UserName:'用户名',
		CompnayName:'公司名称',
		AccountNumber:'账号',
		ContactAddress:'联系地址',
		Submit:'提交',

		FORUMPOSTEDITING:'论坛帖子编辑',
		BothEnglishandChinesePost:'同时编辑中英文帖子',
		OnlyEnglishPost:'只编辑英文帖子',
		OnlyChinesePost:'只编辑中文帖子',
		EnglishPost:'英文帖子',
		Title:'标题',
		ForumPostKeyword:'论坛帖子关键词',
		DaemandPostKeyword:'需求帖子关键词',
		DaemandVesselType:'船舶类型',
		DaemandCargoType:'需求货物类型',
		DaemandShareType:'你的需求',
		AddPicture:'添加图片',
		Usemultiplekeywords:'多个关键词用;号结尾 例如：关键词1;关键词2;关键词3;',
		ChinesePost:'中文帖子',
		SaveDraft:'保存草稿',

		DEMANDEDITING:'需求帖',
		
		UserAgreement: '用户协议',


		SERVICE:'服务',
		LOGISTIC:'物流',
		MAKER:'制造商',
		MEDIA:'媒体',
		OWNER:'船东',
		RBYARD:'修造船厂',
		SUPPLIER:'供应商',
		TRAINING:'培训',
		Forum:'论坛',
		LoginAccount:'登录账号',
		Noaccountleft:'没有账号？',
		Logon:'登录',
		passwordmustbe:'密码必须由8个以上的字母和数字组成',
		passwordNewmustbe:'新密码必须由8个以上的字母和数字组成',
		Slgnup:'注册',
		Notificationmessagelist:'通知消息列表',
		Messageboard:'留言板',
		content:'内容',

		DetailedIntroduction:"详细说明",
		AGENT:'代理',
		//CHARTER:'船东',
		INSURANCE:'保险',
		Leavemessage:"留言",
		DearCustomer:"尊敬的客户，请留下您的留言，我们会尽快回复您。",
		Pleaseleavemessage:"请留言",
		pleasefill:"请填写以下信息，以便顺利联系和沟通。",

		YourName:"姓名:",
		YourEmail:"邮箱",
		YourPhone:"电话:",
		Submitthemessage:"提交留言",

		EnglishName:"英文名称",
		ChineseName:"中文名称",
		corporationEnglishName:"公司英文名称",
		corporationChineseName:"公司中文名称",
		address:"地址",
		Companyaddress:"公司地址",
		Contact:"联系人",
		

		UploadcompanyRegistryfile:"上传公司注册文件",
		UploadCompanybrochure:"上传公司宣传册",
		OfficialWebsite:"官方网站",
		CompanyIntroduction:"公司介绍",
		ADDENGLISHDESCRIPTION:"添加英文描述",
		ADDCHINESEDESCRIPTION:"添加中文描述",
		BusinessKeywordEntry:"业务关键词输入",
		BusinessKeyword:"业务关键词",

		Product:"产品",
		ServiceIntroduction:"服务介绍",
		Habout:"关于我们",


		userName:"用户名",
		Email:"邮箱",
		MobileNo:"手机号",
		Accountinformation:"账号信息",
		Myservice:"我的服务",
		Mywallet:"我的钱包",
		Pleaseentertherechargeamount:"请输入充值金额",
		balance:"余额",
		topup:"充值",
		Subscribe:"开通",
		Transactionrecord:"交易记录",
		Invitationcode:"邀请码",


		changePassword:"修改密码",
		CloseAnAccount:"注销账号",
		oldpassword:"旧密码",
		newpassword:"新密码",
		confirmpassword:"确认密码",
		confirmNewpassword:"确认新密码",

		YourAccountincreaseshared:'使用您分享的邀请码注册，每有一位用户注册成功，您的账户‘环球币’将会增加1',
		GenerateInvitationCode:'生成邀请码',
		CopywithWebURL:'复制带WebURL',
		searchwhatyouareinterestedin:'搜索您感兴趣的内容',

		Tradingdate:"交易日期",
		OrderNo:"订单号",
		Service:"服务",
		Amount:"交易金额",
		InvoiceapplicationCombined:"发票申请(合并)",

		Applyforbilling:"申请开票",
		ApplyBillingApplied:"已申请开票",
		Confirmationbilling:"确认开票",
		Servicetype:"服务类型",
		Timeperiod:"服务时间",
		season:"季度",
		year:" 年度",
		month:" 月度",

		Amountpaid:"充值金额",
		Selectpaymentmethod:"选择付款方式",
		Pleaseentertherechargeamount:"请输入需要充值的环球币数量 (余额≤100.00)",
		Pleaseselectarechargemethod:"请选择充值方式",
		Rechargesuccessfully:"充值成功",
		Rechargefailed:"充值失败",
		Pleaseenteryourbillingemail:"请输入开票邮箱",
		BillingInfo:"开票信息",
		Pleaseenteryourbillinginformation:"请输入开票信息",
		Successfulbilling:" 开票成功",
		Twopasswordsdonotmatch:"两次密码不匹配",
		Thepasswordmustbeatleast8characterslong:"密码长度不能少于8位",
		ThepasswordmustcontainbothEnglishandnumericcharacters:"密码必须同时包含 字母 和数字字符",
		Modifiedsuccessfully:"修改成功",
		Modificationfailed:"修改失败",

 		PassworderRrororaccountdoesnotexist:"密码错误或者账号不存在",
		Theinvitationcodehasbeencopiedtotheclipboard:"邀请码已复制到剪贴板",
		Yourtopupamountcannotexceedthebalance:"您的充值金额不能超过余额",



		Yousureyouwanttotopitup:'你确定要充值',
		Enterpriseboothservice:"企业展位服务",
		Rechargetype:"企业展台服务订购",

		Balancerecharge:"余额充值",
		DemandPayment:"需求 支付",
		PersonalIntroduction:"个人介绍",
		PersonalCareerorExperienceIntroduction:"个人职业/经验介绍",
		ViewAllComments:"查看所有评论",


		vesseloffer:'你可以提供什么类型的船只?',
		Cargooffer:'您需要运输什么类型的货物?',
		Spareoffer:"你可以提供什么备件?",
		serviceOffer:'你可以提供什么服务?',
		Susupervioffer:'你可以提供什么监督服务?',
		Engineeoffer:'你可以提供什么工程服务?',
		demandoffer:'你可以提供一定的需求?',

		publish:'发布',

		Placeofloading: "装货地点",
		Placeofdischarge: "卸货地点",

		RequirementRelease: "需求发布",
		Usersposttheirownneeds: "用户发布自己的需求",
		Requirementtype: "需求类型",
		Budgetscope: "预算范围",
		Phone: "手机号",
		DearCustomerpleaseofferyourvaluablesuggestionsforourfurtherimprovement:"亲爱的客户，请提供您宝贵的建议，以便我们进一步改进",
		pleasefillinthebelowinformationforsmoothcontactandcommunication:"请填写以下信息，以便我们顺利联系和沟通",

		Notyetopened:"暂未开通",
		Customerservice:"客户服务",
		Contactemail:"联系邮箱",
		Contactnumber:"联系电话",
		LoadingLocation:"装货地点",
		LocationNeed:"地点",
		UnloadingLocation:"卸货地点",
		DepartureLocation:"出发地点",
		ArrivalLocation:"到达地点",
		Paymentmethod:"支付方式",
		Releaserequirement:"发布需要",
		Globalcurrency:"全球货币",
		perhaps:"或者",
		Englishtitle:"英文标题",
		Chinesetitle:"中文标题",
		Alreadyonthecurrentpage:"已在当前页面",
		PleaseuploadthecoverimageclicktheUploadimagebutton:"请上传头像",
		Pleasegotothepersonalaccounttoopentheenterpriseboothservice:"请前往个人账户开通企业展位服务",
		Pleaseselectapaymentmethod:"请选择支付方式",
		Savedraftsuccessfully: "保存草稿成功",
		Releasesuccessfully: "发布成功",
		Paymentsuccess: "支付成功",
		Pleasefillincountryregion:"请填写国家/地区",
		Copiedlink:"已复制链接",
		Controls:"操作",
		USERCENTER:"用户中心",
		HOMEPAGE:"主页",
		CorporateBoothServicemon:"企业展台服务开通",
		CorporateBoothServiceQua:"企业展台服务(季度)",
		CorporateBoothServiceYea:"企业展台服务(年度)",
		Thetotalamountafterrechargecannot:'充值后的总金额不能大于100 UNI_COIN 且最少充值1 UNI_COIN',
		EnterOneUsername:"请输入1-20位用户名",
		EnterOneEmail:"请输入1-50位邮箱",
		EnterOnePassword:"请输入正确的密码",
		Pleaseenterthecorrectpassword:"请输入正确的密码",
		Pleasereadtheuseragreement:"请阅读用户协议",
		Registrationsuccessful:"注册成功",
		Sendsuccessfully:"发送成功",
		EnterEmailCode:"请输入邮箱验证码",
		EnterOneConfirmPassword:"请输入确认密码",
		Twopasswordsareinconsistent:"两次密码不一致",
		Resetsuccessful:"重置成功",
		Loginsuccessful:"登录成功",
		HideMyHomepage:"隐藏我的主页",
		NotAvailable:" 该用户主页不可见",
		UserHomepageHidden:"用户已隐藏主页",
		Pleaseenterthename:"请输入名字",
		Pleaseselectacountry:"请选择国家",
		Pleaseentercompanyprofile:"请填写简介",
		Pleaseenterthewebsite:"请填写网址",
		PleaseentertheEnglishname:"请填写英文名称",
		PleaseentertheChinesename:"请填写中文名称",

		serviceintro:"服务介绍",
		Useragreement:"用户协议",
		tremsandconditions:"用户条款",
		YouarenotloggedinGotologin:"您尚未登录，请先登录",
		Operationsuccessful:"操作成功",
		Pleaseenterthecommentcontent:"请输入评论内容",
		Commentsuccessful:"评论成功",
		Jumpfailed:"跳转失败",
		Copysuccessfully:"复制成功",
		Exitsuccessfully:"退出成功",
		Pleaseenterthecorrectemailaddress:"请输入正确的邮箱地址",
		PleaseenterthecorrectoneMobileNo:"请输入正确的手机号",
		EnterMessage:"请输入留言内容",
		EnterPhoneNumber:"请输入手机号",
		Messageboardbackgroundreplycontent:"留言板回复内容",
		Complaintsandsuggestionsbackgroundreplycontent:"投诉与建议回复内容",
		Alreadyinthecurrentpage:"已经在当前页面",
		Thecurrentuserisnoteditingthehomepage:"当前用户暂未编辑主页",
		Queryfailure:"查询失败",
		Pleasechangeyourpaymentmethod:"请更换支付方式",
		Thebalanceisinsufficientpleaserechargefirst:"余额不足,请先充值",
		Applicationfailed:"申请失败",
		SignOUTsuccessful:"账户注销成功",

		EnterCompnayName:"请输入公司名称",
		EnterAccountNumber:"请输入账号",
		EnterUserName:"请输入用户名",
		EnterMobileNo:"请输入手机号",
		EnterContactAddress:"请输入联系地址",
		Areyousureyouwanttodeleteit:"您确定要删除吗",
		Deletesuccessful:"删除成功",
		Deletionfailed:"删除失败",
		cancelled:"已取消",
		Paymentamount:"支付金额",
		Changesuccessfully:"更改成功",
		EnterTitle:"请输入标题",
		EnterKeyword:"请输入关键词",
		Requestexception:"请求异常",
		EnterContent:"请输入内容",
		Pleaseuploadpictures:"请上传图片",
		Coverpicture:"封面图片",
		UNICOINS:"环球币",
		Pleaseenterthephonenumber:"请输入手机号",
		Enterprisesearch:"企业搜索",
		Confirmexit:"确认退出",
		DemandPostReleaseCost:"需求贴发布需要 ",
		unicoinHk:" '环球币' 或 HKD",
		IsemptyPleaseloginagain:"为空! 请重新登录",
		Uploadfilesizeless:"上传文件大小不能超过35M",
		Thiscontentmayinvolvesensitiveinformation:"此内容可能涉及敏感信息",
		paginationTotal: '分页总条数', 
		vide_title:'您的视频发布请求提交成功，待后台审核通过后，将自动同步到视频区',
		Pleaseuploadthevideo:'请上传视频',
		SelectVideo: '选择视频',
		VideoIntroduction:'视频简介',
		Pleaseenterthevideointroduction:'请输入视频简介',
		Videokeywords:'视频关键词',
		video:'视频',
		
		
		noData:'暂无数据',
		Back:'返回',
		IntroductionEnglish:'英文介绍',
		IntroductionChinese:'中文介绍',
		EnterpriseCategory:'企业类别',
		CountryDistrict:'国家/地区',
		CityServicePort:'城市/服务港口',
		MainProductsServices:'主要产品和服务',
		ProductTitleEnglish:'产品标题英文',
		ProductTitleChinese:'产品标题中文',
		DescriptionEnglish:'描述英文',
		DescriptionChinese:'描述中文',
		TitleChinese:'标题中文',
		TitleEnglish:'标题英文',
		PersonalSkill:'个人技能',
		ViewMore:'查看更多',
		Details:'详情',
		Add1pictureascover:'封面图片',
		Pleaseenterthetitle:'请输入标题',
		Pleaseenterthekeyword:'请输入关键词',
		Pleasefollowlawsandregulations:'请遵守法律法规',
		ViewDetails:'查看详情',
		OtherDemands:'其他需求',
		HomepageLink:'主页链接',
		Home:'主页',
		UserCenter:'用户中心',
		UploadImage:'上传图片',
		NoData:'暂无数据',
		SubmitComment:'提交评论',
		AddComment:'添加评论',
		TotalComments:'共',
		Comments:'评论',
		Reply:'回复',
		ReplyComment:'回复评论',
		Pleaseenteryourreply:'请输入您的回复',
		DemandCategory:'需求类型',
		DemandPostKeyword:'需求发布关键',
		RecommendedDemands:'推荐需求',
		DemandVessel:'需求船型',
		CityPort:'城市港口',
		AllDemands:'所有需求',
		Pleaseentervesseltype:'请输入船舶类型',
		DemandCommunity:'需求',
		Refresh:'刷新',
		DemandCargo:'货物类型',
		Pleaseentercargotype:'请输入货物类型',
		Location:'位置',
		DemandKeyword:'需求关键词',
		Pleaseenterkeyword:'请输入关键词',
		ForumCommunity:'论坛社区',
		SearchKeyword:'搜索关键词',
		AllForumPosts:'所有论坛帖子',
		VideoCategory:'视频类别',
		VideoKeyword:'视频关键词',
		BusinessAD:'产品/服务展示',
		TechSeminar:'技术研讨',
		Pleaseuploadvideo:'请上传视频',
		VideoFormatTip:'视频格式提示',
		VideoPublish:'视频发布',
		VideoBrowse:'视频',
		HotSearch:'热门搜索',
		SearchYourInterest:'搜索你感兴趣的视频',
		LoadMore:'加载更多',
		ServiceIntroduction:'服务介绍',
		UserGuide:'用户指南',
		MessageContent:'消息内容',
		Unread:'未读',
		Read:'已读',
		PleaseSelect:'请选择',
		CompanyName:'公司名称',
		ServiceYouAreLookingFor:'搜索服务',
		RecommendedCategories:'推荐分类',
		Delete:'删除',
		PostCategory:'帖子分类',
		All:'全部',
		AboutUs:'关于我们',
		HotDemands:'热门需求贴',
		Pleaseenterthepassword:'请输入密码',
		Rememberme:'记住我',
		RetrievePassword:'找回密码',
		Pleaseentertheinvitationcode:'请输入邀请码',
		UserAgreement:'用户协议',
		Uploadsuccessful:'上传成功',
		Uploadfailed:'上传失败',
		Uploading:'上传中...',
		Imagecanonlybeuploadedviathetoolbar:'图片请通过工具栏按钮上传',
		Thereiscurrentlynocontentavailableforviewing:'暂无内容可查看',
		Youarenotloggedinpleaselogin:'您未登录，请登录',
		Failedtoobtaindetails:'获取详情失败',
		Operationfailed:'操作失败',
		Failedtopublish:'发布失败',
		Publishing:'发布中...',
		Saving:'保存中...',
		Savefailed:'保存失败',
		Pleasefillinthecompleteloadingandunloadinglocations:'请填写完整的装货地点和卸货地点',
		Pleasefillinthecompletedepartureandarrivallocations:'请填写完整的出发地点和到达地点',
		Pleasefillinthelocationinformation:'请填写地点信息',
		Pleaseenteryourmessage:'请输入内容和插入图片',
		PleaseenterVideomessage:'请输入内容',
		Pleaseenteryouremail:'请输入邮箱',
		Submissionsuccessful:'提交成功',
		Submissionfailed:'提交失败',
		Submitting:'提交中...',
		Submissionfailedpleasetryagainlater:'提交失败，请稍后重试',
		Sending:'发送中...',
		Resendinseconds:'秒后重新发送',
		Failedtosend:'发送失败',
		Sendingfailedpleasetryagainlater:'发送失败，请稍后重试',
		Pleaseentertheverificationcode:'请输入验证码',
		Pleaseenteranewpassword:'请输入新密码',
		Pleaseconfirmthenewpassword:'请确认新密码',
		Thepasswordsenteredtwiceareinconsistent:'两次输入的密码不一致',
		Resettinginprogress:'重置中...',
		Passwordresetsuccessful:'密码重置成功',
		Resetfailed:'重置失败',
		Resetfailedpleasetryagainlater:'重置失败，请稍后重试',
		Failedtoretrievethelist:'获取列表失败',
		Refreshsuccessful:'刷新成功',
		Loggingin:'登录中...',
		Loginfailed:'登录失败',
		Likesuccessful:'点赞成功',
		Unlike:'取消点赞',
		Linkcopied:'链接已复制',
		Copyfailed:'复制失败',
		Commentfailed:'评论失败',
		Pleaseenterthereplycontent:'请输入回复内容',
		Replysuccessfully:'回复成功',
		Replyfailed:'回复失败',
		Pleasereadandagreetotheuseragreement:'请阅读并同意用户协议',
		Registering:'注册中...',
		Registrationfailed:'注册失败',
		determine:'确定',
		Areyousureyouwanttocancelthecollection:'确定要取消收藏吗',
		Unsubscribedsuccessfully:'取消收藏成功',
		Areyousureyouwanttocancelthelike:'确定要取消点赞吗',
		Unsubscribedlikesuccessfully:'取消点赞成功',
		Areyousureyouwanttodeletethedraft:'确定要删除草稿吗',
		Passworderrororaccountdoesnotexist:'密码错误或账号不存在',
		Thetotalamountafterrechargecannotexceed100ortherechargeamountcannotbelessthan1:'充值后总金额不能超过100或充值金额不能小于1',
		Activatedsuccessfully:'开通成功',
		Openingfailed:'开通失败',
		Failedtoobtainservicefee:'获取服务费用失败',
		Videouploadedsuccessfully:'视频上传成功',
		Videouploadfailedpleasetryagain:'视频上传失败，请重试',
		Videouploadfailed:'视频上传失败',
		Pleaseuploadthevideo:'请上传视频',
		WhatTypeofSpareyoucanoffer:'您可以提供什么备件？',
		WhatTypeofServiceyoucanoffer:'您可以提供什么服务？',
		WhatTypeofSupervisionyoucanoffer:'您可以提供什么监督服务？',
		WhatTypeofEngineeringServiceyoucanoffer:'您可以提供什么技术服务？',
		Whatyoucanoffer:'您可以提供什么？',
		ship:'船舶',
		TechnologyManagement:'技术管理',
		goods:'货物',
		FinancialManagement:'财务管理',
		Popularforumposts:'热门论坛贴',
		IndividualAccount:'个人账户',
		videosize:'视频文件大小',
		Pleaseselectavideofileídeo:'请选择视频文件',
		Maximumvideosizelimit:'视频最大限制',
		Pleaseentermessage:'请输入内容',
		CollectSuccessfully:'收藏成功',
		ViewReply:'展开',
		HideReply:'隐藏',
		Selecttime:'选择时间',
		Edit:'编辑',
		AIFiltering:'您发布的视频正在审核中，这个过程需要5-10分钟',
		PleaseUploadLogoPhoto:'请上传LOGO图片',
		IndividualHomepage:'个人主页',
		EnterpriseHomepage:'企业主页',
		Notification:'通知',
		ExhibitionBooth:'企业展台服务',
		PasteNotAllowed:'当前内容禁止粘贴',
    }
	
}
export default zh;
